import type { Currency } from "@/lib/domain/Currency";
import type { PriceSource } from "@/lib/domain/PriceSource";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface PublicCollectionCurrencyAndPriceSourceResponseModel {
	readonly currency: Currency;
	readonly priceSource: PriceSource;
}

export const usePublicCollectionCurrencyAndPriceSource = (shareToken: string, enabled: boolean) => {
	const http = useHTTP("UseIfPresent");
	return useHTTPQuery({
		queryKey: ["publicCollectionCurrencyAndPriceSource", shareToken],
		enabled,
		queryFn: () => {
			return http<PublicCollectionCurrencyAndPriceSourceResponseModel>({
				method: "GET",
				url: `/collection/public/${shareToken}/currency-price-source`
			});
		}
	});
};
